module.exports = __webpack_public_path__ + "media/images/emoticons/telephone-37abe911be1bf3ce7097bdcbcbe3a22a.gif";